module.exports = __webpack_public_path__ + "static/media/video_consent_audio_hin.47edbd02.mp3";